import { GetterTree } from "vuex";

import { RootState } from "@/store/root";
import { LoginState } from "./loginTypes";

export const getters: GetterTree<LoginState, RootState> = {};
